module.exports = __webpack_public_path__ + "media/components/country-flag/static/cn-e1b1d76ef5e1012571cdbc057f80ab28.svg";